import { Mail, Phone } from 'lucide-react';
import { useNavigate } from 'react-router';
import { IconButtonTemplate } from '../../buttons/IconButtonTemplate';
import { WhatsAppIcon } from '../../icons';
import { ButtonTemplate } from '../../buttons/ButtonTemplate';

import { colors, successMessages } from '../../../../data/constants';
import { handleCopy, handleWhatsUpClick } from '../../../../utils/utils';
import { fullName } from '../../../../utils/ui';

export const ContactInfo = ({
  contact = {},
}) => {
  const { first_name, last_name, role, phone, email } = contact;
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-3">
      <div>
        <span className="text-xl text-blackColor font-bold">{`${fullName(first_name, last_name)}${role?.title ? ` (${role.title})` : ''}`}</span>
      </div>

      {phone && phone.length > 0 && (
        <div className="flex items-center gap-2 flex-wrap">
          <Phone
            color={colors.darkBlueColor}
            size={14}
          />

          <span className="text-xs text-blackColor sm:text-sm">{phone}</span>

          <span
            onClick={() => handleCopy(phone, successMessages.copyPhone)}
            className="text-xs text-darkBlueColor cursor-pointer sm:text-sm"
          >
            (Copy)
          </span>

          <IconButtonTemplate
            size={16}
            handleClick={() => handleWhatsUpClick(phone)}
            icon={WhatsAppIcon}
            classes={'border-white'}
            isSmallBorder={true}
          />
        </div>
      )}

      {email && email.length > 0 && (
        <div className="flex items-center gap-2 flex-wrap">
          <Mail
            color={colors.darkBlueColor}
            size={14}
          />

          <span className="text-xs text-blackColor sm:text-sm">{email}</span>

          <span
            onClick={() => handleCopy(email, successMessages.copyEmail)}
            className="text-xs text-darkBlueColor cursor-pointer sm:text-sm"
          >
            (Copy)
          </span>

          <ButtonTemplate
            text={'Send email'}
            handleClick={() => navigate('/emails')}
            classes={
              'border-whiteColor bg-whiteColor text-darkBlueColor underline'
            }
            isSmall={true}
            isSmallBorder={true}
          />
        </div>
      )}
    </div>
  );
};
